import React, { useContext, useRef, useState } from 'react';
import { useLazyQuery } from '@apollo/client';
import { getAllScenarios } from 'gqlQueries/priceSimulator';
import { fetchAllScenariosParser } from 'parser/priceSimulator/priceSimulatorDataParser';
import { UserContext } from 'contexts/ConfigContext';
import { getConfig } from 'utils/helperMethods';
import { ConfigKeys } from 'utils/Enums';
const errorMessage: string = 'Something went wrong!';

function useFetchAllScenarios() {
    const { appConfig } = useContext(UserContext);
    const { dataSources } = getConfig(ConfigKeys.PRICE_SIMULATOR, appConfig);
    const [loading, setLoading] = useState<boolean>(false);
    const [error, setError] = useState<null | string>(null);
    const [data, setData] = useState<any>(null);
    const [count, setCount] = useState<number>(0);
    const offsetRef = useRef(0);

    const [fetchAllScenarios] = useLazyQuery(getAllScenarios, {
        onCompleted: onFetchComplete,
        onError: onFetchError,
        fetchPolicy: 'network-only',
    });

    //called when fetching is complete
    function onFetchComplete(payload: any) {
        try {
            const { getScenariosList } = payload;
            //if data present parse it
            if (getScenariosList?.length > 0) {
                const parsedData = fetchAllScenariosParser(getScenariosList, dataSources);

                setData(parsedData);
                return;
            }
            setData(null);
        } catch (error) {
            console.error(errorMessage, error);
            onFetchError(error);
        } finally {
            setLoading(false);
        }
    }

    //called when API throws an error
    function onFetchError(error: any = errorMessage) {
        setData([]);
        setLoading(false);
        setError(error);
    }

    return {
        loading,
        error,
        data,
        fetchAllScenarios: (variables: any) => {
            offsetRef.current = variables.variables.offset;
            setLoading(true);
            setError(null);
            fetchAllScenarios(variables);
        },
    };
}

export { useFetchAllScenarios };
